import Arrow from "../LogoSVG/Arrow";

function ConnectMobileItem({ Logo, url, name }: any) {
  return (
    <div className="flex flex-start items-center mb-3">
      <a
        className="w-full bg-gray-2 flex flex-row items-center p-4 rounded-lg justify-between"
        target="_blank"
        href={url}
      >
        <div className="flex flex-row items-center" style={{ color: "white" }}>
          <Logo />
          <p className="ml-4 text-[16px] leading-7">{name}</p>
        </div>
        <div
          style={{
            color: "#b4b4b4",
          }}
        >
          <Arrow />
        </div>
      </a>
    </div>
  );
}

export default ConnectMobileItem;
